import { LoadingState } from '../shared/ui/loading-state';

export const RouteHydrationFallback = () => <LoadingState rows={4} />;
